import { PageFooterData } from 'components/PageFooter/types/PageFooterData';
import { getMainInternshipsSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainInternshipsSearchRoutePath';
import { getMainJobsSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainJobsSearchRoutePath';
import { getMainOrgSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainOrgSearchRoutePath';
import { getMainVolopsSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainVolopsSearchRoutePath';
import { mainPostAListingRoute } from 'modules/main/main.routes';

export const pageFooterDataEs: PageFooterData = {
  findAJob: {
    title: 'Encuentra empleo',
    links: [
      {
        type: 'jobs',
        title: 'Empleos',
        href: getMainJobsSearchRoutePath({ lang: 'es' }),
      },
      {
        type: 'internships',
        title: 'Pasantías',
        href: getMainInternshipsSearchRoutePath({ lang: 'es' }),
      },
      {
        type: 'organizations',
        title: 'Organizaciones',
        href: getMainOrgSearchRoutePath({ lang: 'es' }),
      },
      {
        type: 'career-advice',
        title: 'Desarrollo de carrera',
        href: '/es/accion?categories=empleocambiamundo&pq=',
      },
    ],
  },
  takeAction: {
    title: 'Actúa',
    links: [
      {
        type: 'volops',
        title: 'Voluntariado',
        href: getMainVolopsSearchRoutePath({ lang: 'es' }),
      },
      {
        type: 'events',
        title: 'Asiste a un Evento',
        href: getMainVolopsSearchRoutePath({
          lang: 'es',
          filters: { type: 'VOLOP', actionType: ['EVENT'] },
        }),
      },
      {
        type: 'knowledge-base',
        title: 'Centro de Recursos para Recaudación de Fondos',
        href: '/es/recursos-recaudacion-fondos',
      },
    ],
  },
  postOnIdealist: {
    title: 'Publica',
    links: [
      {
        type: 'post-a-listing',
        title: 'Publica una Oportunidad',
        href: mainPostAListingRoute.with({}),
      },
      {
        type: 'create-org',
        title: 'Suma tu Organización',
        href: '/organizations/create',
      },
      {
        type: 'create-community-group',
        title: 'Suma tu Colectivo Ciudadano',
        href: '/organizations/create',
      },
      {
        type: 'employer-resources',
        title: 'Herramientas para Reclutadores',
        href: '/es/orgs/encuentra-talento',
      },
      {
        type: 'help-center',
        title: 'Centro de Ayuda',
        href: '/es/ayuda',
      },
    ],
  },
  aboutUs: {
    title: 'Acerca de',
    links: [
      {
        type: 'our-mission',
        title: '¿Qué buscamos?',
        href: '/es/about',
      },
      {
        type: 'our-team',
        title: 'Nuestro Equipo',
        href: '/es/acerca-de/nuestro-equipo',
      },
      {
        type: 'donate',
        title: 'Donar a Idealist',
        href: '/es/dona',
      },
    ],
  },
  learnMore: {
    title: 'Más información',
    links: [
      {
        type: 'help-center',
        title: 'Ayuda',
        href: '/es/ayuda',
      },
      {
        type: 'contact-us',
        title: 'Contáctanos',
        href: '/es/about/contactanos',
      },
      {
        type: 'terms-of-service',
        title: 'Términos de Servicio',
        href: '/en/terms-of-service',
      },
      {
        type: 'privacy-policy',
        title: 'Política de Privacidad',
        href: '/en/privacy-policy',
      },
      {
        type: 'site-map',
        title: 'Mapa del Sitio',
        href: '/es/mapasitio',
      },
    ],
  },
};
